var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonCloseLargeLightGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144578",
  fill: "none",
  d: "M0 0h40v40H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.999 21.014l-6.76 6.76a.708.708 0 01-.5.218.685.685 0 01-.514-.218.7.7 0 01-.225-.508.7.7 0 01.225-.508l6.76-6.76-6.76-6.76a.708.708 0 01-.218-.5.685.685 0 01.218-.514.7.7 0 01.508-.225.7.7 0 01.508.225l6.76 6.76 6.76-6.76a.708.708 0 01.5-.218.685.685 0 01.514.218.7.7 0 01.225.508.7.7 0 01-.225.508L21.015 20l6.76 6.76a.708.708 0 01.218.5.685.685 0 01-.218.514.7.7 0 01-.508.224.7.7 0 01-.508-.224z",
  fill: "#999"
})));
export default __webpack_public_path__ + "static/button-close-large-light-gray.3719dbc95cab76a678c1e792b1cd3651.svg";
export { SvgButtonCloseLargeLightGray as ReactComponent };